import React, {useEffect} from "react";
import Button from "./Button";

const InfoBodyApple = () => {
    useEffect(() => {
        document.title = "Apple Pay";
    }, [])

    return (
        <div className="h-fit w-full bg-slate-200 px-40 mobile:px-0 laptop:px-20">
            <div className="h-full w-full bg-white">
                <div className="h-full w-full px-36 py-10 space-y-5 mobile:space-y-2.5 mobile:py-0 mobile:px-5 text-justify tablet:px-16 mobile:text-sm">
                    <img src="./apple_pay/june-update/apple-info-top.jpg" className="flex justify-center mobile:hidden " alt="Banner"/>
                    <img src="./apple_pay/june-update/apple-info-top-mobile.jpg" className="justify-center object-cover hidden mobile:flex" alt="Banner"/>
                    <p className="font-bold text-xl text-[#0987F3]">Харилцагч Танд энэ өдрийн мэнд хүргэе.</p>
                    <p>Хаана ч хэзээ ч хүссэн газартаа Apple Рау -ээ уншуулаад 100 ЯЛАГЧИЙН нэг болоорой.</p>
                    <h5 className={"text-[#0987F3] font-medium"}>Урамшууллын хугацаа</h5>
                    <p>2025.06.01-2025.08.31-ний өдрийг дуустал үргэлжилнэ.</p>
                    <p className={"text-[#0987F3] pb-0 mb-0 font-medium"}>Хөтөлбөрийн шагнал</p>
                    <div className={"pl-2 pt-0 pb-0 mb-0 mobile:hidden"}>
                        <p className="mb-5 pt-0 mt-0  ">Сар бүр:</p>
                        <ul className={"list-style-none mt-0 pt-0 ml-5 "}>
                            <li>🎁 100 харилцагч - Apple 25$ GIFT-CARD</li>
                        </ul>
                        <p className="mb-5 mt-7 ">Улирал:</p>
                        <ul className={"list-style-none mt-0 pt-0 ml-5 "}>
                            <li>🎁 1 харилцагч - Банкны өөрийн эх үүсвэрийн ОРОН СУУЦНЫ зээлийн хүүгийн хөнгөлөлт эдлэх эрх</li>
                            <li>🎁 100 харилцагч - Apple 25$ GIFT-CARD</li>
                        </ul>
                    </div>
                    <table className={"mobile:block mobile:w-full hidden "}>
                        <tbody>
                            <tr className={"bg-blue-500 text-white text-center font-medium "}>
                               <td colSpan={2} className={"p-2"}>
                                   Сар бүр
                               </td>
                            </tr>
                            <tr className={""}>
                                <td className={"w-1/4 text-center p-3"} >🎁 100 харилцагч </td>
                                <td className={"w-[75%] border-l-2 text-justify p-3"}>Apple 25$ GIFT-CARD</td>
                            </tr>
                            <tr className={"py-1"}>
                                <td colSpan={2} className={" p-2  text-center font-medium bg-blue-500 text-white "}>
                                    Улирал
                                </td>
                            </tr>
                            <tr>
                                <td className={"w-1/4 text-center p-3"} >🎁 1 харилцагч </td>
                                <td className={"w-[75%] border-l-2 text-justify p-3"}>Банкны өөрийн эх үүсвэрийн ОРОН СУУЦНЫ зээлийн хүүгийн хөнгөлөлт эдлэх эрх</td>
                            </tr>
                            <tr className={"border-b-2"}>
                                <td className={"w-1/4 text-center p-3"} >🎁 100 харилцагч </td>
                                <td className={"w-[75%] border-l-2 text-justify p-3"}>Apple 25$ GIFT-CARD</td>
                            </tr>
                        </tbody>
                    </table>
                    <img src="./apple_pay/june-update/apple-info-bottom-mobile.jpg" className="hidden m-0 p-0 justify-center mobile:flex " alt="Banner"/>

                    <h5 className={"text-[#0987F3] font-medium"}>Урамшуулалт хөтөлбөрт хэрхэн оролцох вэ?</h5>
                    <ul className={"list-none mobile:hidden"}>
                        <li>
                            <span className={"text-xs"}>○</span>   Apple Pay-д ХХБ-ны мастер виртуал картаа холбох
                        </li>
                        <li>
                            <span className={"text-xs"}>○</span>  Apple Pay-р төлбөрт тооцоогоо гүйцэтгэн ХАМГИЙН ОЛОН гүйлгээ хийх
                        </li>
                        <li>
                            <span className={"text-xs"}>○</span>  Apple Pay-р ecommerce (цахим худалдан авалт) гүйлгээ хийсэн нэгж гүйлгээг 2-оор тооцогдох боломжтой.
                        </li>
                    </ul>
                    <table className={"w-full hidden mobile:block"}>
                        <tbody>
                        <tr>
                            <td className={"w-1/12 text-center"}><span className={"text-xs"}>○</span></td>
                            <td className={"text-justify p-3"}>Apple Pay-д ХХБ-ны мастер виртуал картаа холбох</td>
                        </tr>
                        <tr>
                            <td className={"w-1/12 text-center"}><span className={"text-xs"}>○</span></td>
                            <td className={"text-justify p-3"}>Apple Pay-р төлбөрт тооцоогоо гүйцэтгэн ХАМГИЙН ОЛОН гүйлгээ хийх</td>
                        </tr>
                        <tr>
                            <td className={"w-1/12 text-center"}><span className={"text-xs"}>○</span></td>
                            <td className={"text-justify p-3"}>Apple Pay-р ecommerce (цахим худалдан авалт) гүйлгээ хийсэн нэгж гүйлгээг 2-оор тооцогдох боломжтой.</td>
                        </tr>
                        </tbody>
                    </table>
                    <img src="./apple_pay/june-update/apple-info-bottom.jpg" className="flex justify-center mobile:hidden " alt="Banner"/>
                    <h5 className={"text-[#0987F3] font-medium"}>Урамшууллын эздийг тодруулах өдрүүд</h5>
                    <table className={"border-collapse w-full p-10 border-0"}>
                        <thead className={"text-white bg-blue-500"}>
                            <tr>
                                <th className="border border-gray-300 w-1/3 text-center">Хамрах хугацаа</th>
                                <th className="border border-gray-300 w-1/3 text-center">Тохирол болох өдөр</th>
                                <th className="border border-gray-300 w-1/3 text-center">Тохирол болох суваг</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 text-center">2025.06.01 - 2025.06.30</td>
                                <td className="border border-gray-300 text-center">2025.07.15</td>
                                <td className="border border-gray-300 text-center align-middle mobile:text-xs" rowSpan="3">Худалдаа, хөгжлийн банкны албан ёсны Facebook хуудсанд шалгарсан харилцагчдын мэдээллийг байршуулна.</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 text-center">2025.07.01 - 2025.07.31</td>
                                <td className="border border-gray-300 text-center">2025.08.15</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 text-center">2025.08.01 - 2025.08.31</td>
                                <td className="border border-gray-300 text-center">2025.09.15</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="border border-black px-10 py-3">
                        <h5 className={"text-red-500 font-semibold"}>Санамж:</h5>
                        <ul className={"list-disc"}>
                            <li>
                                Зохиомол байдлаар гүйлгээгээ нэмэгдүүлсэн тохиолдолд хөтөлбөрт хамрагдах боломжгүй байна.
                            </li>
                            <li>
                                Зөвхөн Apple Pay-р хийгдсэн гүйлгээг тооцно
                            </li>
                        </ul>
                    </div>

                    <div className="w-full flex justify-center pb-10">
                        <Button
                            name="Apple pay гүйлгээний тоог шалгах"
                            link="https://www.cardcentre.mn/eregister/index.php?appid=apple"
                            style="font-bold text-[#0987F3] bg-white rounded-xl shadow-xl w-[300px] h-[80px] hover:bg-[#0987F3] hover:text-white border border-[#0987F3]"/>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default InfoBodyApple;